const GreenlandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111503)">
      <path
        d="M0 20C0 8.95437 8.95437 0 20 0C31.0456 0 40 8.95437 40 20C39.1305 20 20 22.6087 20 22.6087L0 20Z"
        fill="#F0F0F0"
      />
      <path d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20" fill="#D80027" />
      <path
        d="M13.9129 29.565C19.1956 29.565 23.4781 25.2825 23.4781 19.9998C23.4781 14.7171 19.1956 10.4346 13.9129 10.4346C8.63016 10.4346 4.34766 14.7171 4.34766 19.9998C4.34766 25.2825 8.63016 29.565 13.9129 29.565Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.34766 19.9998C4.34766 14.7172 8.63016 10.4346 13.9129 10.4346C19.1957 10.4346 23.4781 14.7171 23.4781 19.9998"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111503">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GreenlandSvg;
